import { MetaData } from "../features/news-api-slice";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import TagManager from 'react-gtm-module';

const MetaDataHelmet = (data: MetaData) => {

    useEffect(() => {
        if (data.title==='') return;
        if (data.title.toUpperCase()==='HIDIVE NEWS') return;

        let dataLayer = {
            event: 'virtualPageView',
            dlPageTitle: data.title,
            dlPageUrl: window.location.href,
        };

        TagManager.dataLayer({ dataLayer });
    }, [data.title]);

    const logoImage = "//static.hidive.com/misc/HD_Logo_PR.png";
    return (
        <Helmet>
            <title>{data.title}</title>
            <meta property='title' content={data.title} />
            <meta property='description' content={data.description} />
            <meta property='keywords' content={data.keywords} />
            <meta property='title' content={data.title} />
            <meta property="og:title" content={data.title} />
            <meta property="og:description" content={data.description} />
            <meta property="og:type" content={data.type} />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:image" content={logoImage} />
            <meta property="og:site_name" content="HIDIVE" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="HIDIVE" />
            <meta name="twitter:title" content={data.title} />
            <meta name="twitter:description" content={data.description} />
            <meta name="twitter:image:src" content={logoImage} />
        </Helmet>
    )
};

export default MetaDataHelmet;